import React, { useState } from 'react';
import { View, TouchableOpacity } from 'react-native';
import { useTranslation } from 'react-i18next';
import * as Clipboard from 'expo-clipboard';
import QText from './QText';
import TextInput from './TextInput';
import CopyIcon from './Icons/CopyIcon';
import CheckIcon from './Icons/CheckIcon';
import { getTrackingLink } from '../utils';

const TrackingLinkSection = ({ queueUserDetail, styles }) => {
  const { t } = useTranslation();
  const [isShowCopiedUrl, setIsShowCopiedUrl] = useState(false);

  const copyToClipboard = async () => {
    await Clipboard.setStringAsync(getTrackingLink(queueUserDetail?.id));
    setIsShowCopiedUrl(true);
    setTimeout(() => {
      setIsShowCopiedUrl(false);
    }, 2000);
  };

  return (
    <View style={styles.sectionContainer}>
      <View style={styles.sectionPartHeadingContainer}>
        <QText style={styles.sectionPartHeadingText}>
          {t('track_joining_position_link')}
        </QText>
      </View>
      <View style={styles.linkContainer}>
        <View style={styles.linkTxtBoxContainer}>
          <TextInput
            theme={{ outerWidth: 2 }}
            style={{ height: 50, fontSize: 12 }}
            value={getTrackingLink(queueUserDetail?.id)}
          />
          <View style={styles.copyBtnContainer}>
            <View style={{ flex: 1, justifyContent: 'center' }}>
              <TouchableOpacity
                activeOpacity={0.6}
                disabled={isShowCopiedUrl}
                onPress={copyToClipboard}
                style={{
                  flexDirection: 'row',
                  alignSelf: 'center',
                }}
              >
                {isShowCopiedUrl ? (
                  <CheckIcon width={20} height={20} color="white" />
                ) : (
                  <CopyIcon width={20} height={20} color="white" />
                )}

                <QText
                  style={{
                    color: 'white',
                    fontSize: 15,
                    fontWeight: 'bold',
                    marginLeft: 5,
                  }}
                >
                  {isShowCopiedUrl ? t('copied') : t('copy')}
                </QText>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </View>
    </View>
  );
};

export default TrackingLinkSection;
